import { isValidCEP } from '@brazilian-utils/brazilian-utils';
import { email, enum as enum_zod, object, string } from 'zod/v4';
import { fixoRegex } from '@/shared/constants/fixo-regex';
import { whatsappRegex } from '@/shared/constants/whatsapp-regex';
import removeNonNumericCharacters from '@/shared/functions/remove-non-numeric-characters';

function toNationalContact(value: string): string {
	const digits = removeNonNumericCharacters(value);
	return digits.startsWith('55') ? digits.slice(2) : digits;
}

export const CreatePreRegistrationSchema = object({
	name: string({ error: (issue) => (issue.input === undefined ? 'O nome é obrigatório' : undefined) }),
	email: email('Insira um e-mail válido'),
	contact: string({
		error: (issue) => (issue.input === undefined ? 'Contato deve ser um número válido' : undefined),
	}).refine(
		(value) => {
			const national = toNationalContact(value);
			return whatsappRegex.test(national) || fixoRegex.test(national);
		},
		{
			error: 'Número inválido. Use (DD) 9 XXXX-XXXX para celular ou (DD) XXXX-XXXX para fixo.',
		},
	),
	cep: string({ error: (issue) => (issue.input === undefined ? 'O CEP é obrigatório' : undefined) }).refine(
		(value) => {
			const cepDigits = removeNonNumericCharacters(value);
			return cepDigits.length === 8 && isValidCEP(cepDigits);
		},
		{ error: 'CEP deve ser um CEP válido' },
	),
	address: string({ error: (issue) => (issue.input === undefined ? 'O endereço é obrigatório' : undefined) }).min(1, {
		error: 'O endereço é obrigatório',
	}),
	neighborhood: string({ error: (issue) => (issue.input === undefined ? 'O bairro é obrigatório' : undefined) }).min(1, {
		error: 'O bairro é obrigatório',
	}),
	city: string({ error: (issue) => (issue.input === undefined ? 'A cidade é obrigatória' : undefined) }).min(1, {
		error: 'A cidade é obrigatória',
	}),
	state: string({ error: (issue) => (issue.input === undefined ? 'O estado é obrigatório' : undefined) }).min(1, {
		error: 'O estado é obrigatório',
	}),
	stateCode: string({ error: (issue) => (issue.input === undefined ? 'O UF é obrigatório' : undefined) }).refine((value) => /^[A-Z]{2}$/.test(value), {
		error: 'O UF é obrigatório',
	}),
	ibge: string({ error: (issue) => (issue.input === undefined ? 'O código IBGE é obrigatório' : undefined) }).min(1, {
		error: 'O código IBGE é obrigatório',
	}),
	profession: enum_zod(['ARQUITETO(A)', 'ENGENHERIO(A) CIVIL', 'DESIGNER DE INTERIORES']).optional(),
});
